/* Live promo callout — re-renders the PDP offer box ("2 in cart — add 1 more…")
   the moment the cart changes, via the Section Rendering API. The cart drawer's
   own promo meter already updates through Prestige's drawer re-render. */
(function () {
  var refreshing = false;

  function refresh() {
    var target = document.querySelector('[data-promo-callout]');
    if (!target || refreshing) return;
    refreshing = true;
    var sectionId = target.getAttribute('data-section-id');
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-promo-callout]');
        var current = document.querySelector('[data-promo-callout]');
        if (fresh && current) current.replaceWith(fresh);
      })
      .catch(function () {})
      .then(function () { refreshing = false; });
  }

  ['cart:change', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refresh, 200); });
  });
})();
